import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Container = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;

    display: flex;
    align-items: center;
    text-align: center;
    color: #4caf50;
  }

  .desc {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    color: #212121;
  }
`;

export const CountDown = styled(Box)`
  margin-top: 15px;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 5px;
`;
